// We shouldn't export colour constants, only use them in the
// semantically-named constants we export

/* eslint no-unused-vars: "off" */

const BLACK_LIGHTEST = '#525252';
const BLACK_LIGHTER = '#333';
const BLACK_BASE = '#000';

const WHITE_BASE = '#fff';
const WHITE_DARKER = '#fefefe';
const WHITE_DARKEST = '#fafafa';

const GRAY_LIGHTEST = '#f1f1f1';
const GRAY_LIGHTER = '#eaeaea';
const GRAY_BASE = '#ccc';
const GRAY_DARKER = '#999';
const GRAY_DARKEST = '#666';

const ORANGE_LIGHTEST = '#fff2cb';
const ORANGE_LIGHTER = '#ffdd7c';
const ORANGE_BASE = '#ffbc00';
const ORANGE_DARKER = '#ff8b00';
const ORANGE_DARKEST = '#ff5800';

const RED_LIGHTEST = '#FF6835';
const RED_LIGHTER = '#e94d19';
const RED_BASE = '#cc3300';
const RED_DARKER = '#c23000';
const RED_DARKEST = '#900';

const BLUE_LIGHTEST = '#dff6ff';
const BLUE_LIGHTER = '#9fdaed';
const BLUE_BASE = '#1ea6f8';
const BLUE_DARKER = '#0081bd';
const BLUE_DARKEST = '#1779b1';

const GREEN_LIGHTEST = '#dcf2a0';
const GREEN_LIGHTER = '#c2e65d';
const GREEN_BASE = '#a3d856';
const GREEN_DARKER = '#7cbd00';
const GREEN_DARKEST = '#6ba300';

const YELLOW_LIGHTEST = '#fffacd';
const YELLOW_LIGHTER = '#fff5ca';
const YELLOW_BASE = '#ebdf78';
const YELLOW_DARKER = '#c0ae13';
const YELLOW_DARKEST = '#5a520f';

//
// Semantical names
//

// TranscodedImage, this color was hard-coded in CSS before so and it
// doesn't belong to the palette above
export const APP_IMAGE_PLACEHOLDER = '#4397e6';

// ItemsContainer
export const ITEM_TRANSCRIPTION_COLOR = ORANGE_DARKER;
export const ITEM_TRANSLATION_COLOR = BLACK_BASE;
export const ITEM_PART_OF_SPEACH_COLOR = BLACK_LIGHTER;
export const ITEM_IN_COURSE_COLOR = GRAY_DARKER;
export const ITEM_IN_COURSE_LINE_COLOR = GRAY_BASE;
export const ITEM_COURSE_COLOR = BLACK_BASE;
export const ITEM_COURSE_HOVER_COLOR = BLUE_BASE;
export const ITEM_CUE_WORD_COLOR = ORANGE_DARKER;
export const ITEM_PROGRESS_LABEL_COLOR = BLACK_LIGHTER;
export const ITEM_PROGRESS_PERCENTAGE_COLOR = BLACK_BASE;

// DifficultyLevel
export const DIFFICULTY_LEVEL_BEGINNER_COLOR = '#4c994c';
export const DIFFICULTY_LEVEL_LOWER_INTERMEDIATE_COLOR = '#2e9975';
export const DIFFICULTY_LEVEL_INTERMEDIATE_COLOR = '#608fbf';
export const DIFFICULTY_LEVEL_UPPER_INTERMEDIATE_COLOR = '#967acc';
export const DIFFICULTY_LEVEL_ADVANCED_COLOR = '#cc5cb9';

// SoundPlayer
export const SOUND_PLAYER_SENTENCE_COLOR = GRAY_DARKER;
export const SOUND_PLAYER_SENTENCE_HOVER_COLOR = '#808080';

// RoundBox
export const ROUNDBOX_BACKGROUND_COLOR = WHITE_BASE;
export const ROUNDBOX_BORDER_COLOR = GRAY_BASE;

// ErrorDecorator
export const ERROR_DECORATOR_TITLE_COLOR = '#517588';

// AnswerConfirmationScreen
export const ANSWER_CONFIRMATION_ANSWER_TEXT_COLOR = '#2255aa';
export const ANSWER_CONFIRMATION_ANSWER_BACKGROUND_COLOR = '#bbddff';
